// NATIVE 
import { useEffect, useState } from 'react';

// INSTALLED 
import { useDispatch, useSelector } from 'react-redux';
import { Grid, IconButton, Tooltip } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

// CUSTOM 
import InputField from '../formFields/InputField';
// import { getFormsDataS } from '../../store/company';
import InputNumeric from '../formFields/InputNumeric';
import CheckboxField from '../formFields/checkBoxField';
import { IDatosBasicos } from '../../commons/interfaces';
import AutocompleteField from '../formFields/autocompleteField';
import DatePickerDefaultField from '../formFields/datePickerDefaultField';
import AutocompleteFieldCountry from '../formFields/autocompleteFieldCountry';
import AutocompleteFieldDepartament from '../formFields/AutocompleteFieldDepartament';


// import InputNumeric from '../formFields';

export const DatosClientes = (props:any) => {


    const dispatch = useDispatch();

    // REDUX
    const { countries_list }:IDatosBasicos  = useSelector( (state:any) => state.company );
    const { departaments_list }:any = useSelector( (state:any) => state.departaments );
    const { municipaly_list }:any = useSelector( (state:any) => state.municipalies );

    const  {  country_list_select } = useSelector( (state:any) => state.country );
      // const  {  workplace_list_select } = useSelector( (state:any) => state.workplace );
      const  {  municipaly_list_select } = useSelector( (state:any) => state.municipalies );
      const  {  departaments_list_select } = useSelector( (state:any) => state.departaments );
      // const  {  type_documents_list_select } = useSelector( (state:any) => state.tipodocumento );
      // const  {  economic_activity_list_select } = useSelector( (state:any) => state.economicactivity );


      console.log('chuchuncaca');
      console.log(country_list_select);


    const [countries,      setCountries]     = useState([]);
    const [departaments,   setDepartaments]  = useState([]);
    const [municipalies,   setMunicipalies]  = useState([]);


    const { formField: {
        // DATOS CLIENTE 
        name,
        address,
        email,
        person_in_charge,
        contact,
        second_person_in_charge,
        second_customer_contact,
        phone,
        start_date,
        status,
        country,
        departament,
        municipaly
      }
    } = props;


    useEffect(() => {
        getDataInputesForm();
     }, []);
 
 
     useEffect(() => {
       setDepartaments(departaments_list_select);
     }, [departaments_list_select]);
 
     useEffect(() => {
       setMunicipalies(municipaly_list);
     }, [municipaly_list]);


     const getDataInputesForm = async () => {

        // const response = await dispatch( getFormsDataS() );

        
        setCountries([]);
        setDepartaments([]);
        setMunicipalies([]);
    }




  return (
    <div>

        <Grid container spacing={2}>
            <Grid item xs={3}>
              <InputField 
                name={name.name}
                label={name.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            <Grid item xs={3}>
            <InputField 
                name={person_in_charge.name}
                label={person_in_charge.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

            <Grid item xs={3}>
              <InputField 
                name={email.name}
                label={email.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

            


            <Grid item xs={3}>
              <InputNumeric 
                name={contact.name}
                label={contact.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            
        </Grid> 
        {/* END GRID  */}

        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid item xs={3}>
                  <AutocompleteFieldCountry
                      options={country_list_select}
                      name={country.name}
                      label={country.label}
                      element={country.name}
                  />
            </Grid>
            <Grid item xs={3}>
                  <AutocompleteFieldDepartament 
                      options={departaments}
                      name={departament.name}
                      label={departament.label}
                      element={departament.name}
                  />
            </Grid>
            <Grid item xs={3}> 
                  <AutocompleteField 
                      options={municipalies}
                      name={municipaly.name}
                      label={municipaly.label}
                      element={municipaly.name}
                  />
            </Grid>
            <Grid item xs={3}>
              <InputField 
                name={address.name}
                label={address.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
        </Grid> 
        {/* END GRID  */}


        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid item xs={3}>
              <InputField 
                name={second_person_in_charge.name}
                label={second_person_in_charge.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            <Grid item xs={3}>
              <InputNumeric 
                name={second_customer_contact.name}
                label={second_customer_contact.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>


            <Grid item xs={3}>
              
              <DatePickerDefaultField label={start_date.label} 
                               name={start_date.name}/>
            </Grid> 

            <Grid item xs={3}>
              <InputNumeric 
                name={phone.name}
                label={phone.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

             
            
            
        </Grid> 
        {/* END GRID  */}

    </div>
  )
}

